import { TFunction } from 'i18next';

export interface PricingPlan {
  name: string;
  price: string;
  period?: string;
  description: string;
  features: string[];
  buttonText: string;
  popular: boolean;
  action?: 'register' | 'contact';
}

// Pre-Accounting specific pricing plans (localized via i18n keys)
export const getPreAccountingPricingPlans = (t: TFunction): PricingPlan[] => [
  {
    name: t('preAccounting.pricing.plans.basic.name'),
    price: t('preAccounting.pricing.plans.basic.price'),
    period: t('preAccounting.pricing.plans.basic.period'),
    description: t('preAccounting.pricing.plans.basic.description'),
    features: t('preAccounting.pricing.plans.basic.features', { returnObjects: true }) as string[],
    buttonText: t('preAccounting.pricing.buttons.selectPlan'),
    popular: false
  },
  {
    name: t('preAccounting.pricing.plans.professional.name'),
    price: t('preAccounting.pricing.plans.professional.price'),
    period: t('preAccounting.pricing.plans.professional.period'),
    description: t('preAccounting.pricing.plans.professional.description'),
    features: t('preAccounting.pricing.plans.professional.features', { returnObjects: true }) as string[],
    buttonText: t('preAccounting.pricing.buttons.selectPlan'),
    popular: true
  },
  {
    name: t('preAccounting.pricing.plans.corporate.name'),
    price: t('preAccounting.pricing.plans.corporate.price'),
    period: t('preAccounting.pricing.plans.corporate.period'),
    description: t('preAccounting.pricing.plans.corporate.description'),
    features: t('preAccounting.pricing.plans.corporate.features', { returnObjects: true }) as string[],
    buttonText: t('preAccounting.pricing.buttons.contact'),
    popular: false
  }
];

// Kiosk specific pricing plans (localized via i18n keys)
export const getKioskPricingPlans = (t: TFunction): PricingPlan[] => [
  {
    name: t('kiosk.pricing.plans.starter.name'),
    price: t('kiosk.pricing.plans.starter.price'),
    period: t('kiosk.pricing.plans.starter.period'),
    description: t('kiosk.pricing.plans.starter.description'),
    features: t('kiosk.pricing.plans.starter.features', { returnObjects: true }) as string[],
    buttonText: t('kiosk.pricing.buttons.tryFree'),
    popular: false
  },
  {
    name: t('kiosk.pricing.plans.professional.name'),
    price: t('kiosk.pricing.plans.professional.price'),
    period: t('kiosk.pricing.plans.professional.period'),
    description: t('kiosk.pricing.plans.professional.description'),
    features: t('kiosk.pricing.plans.professional.features', { returnObjects: true }) as string[],
    buttonText: t('kiosk.pricing.buttons.tryFree'),
    popular: true
  },
  {
    name: t('kiosk.pricing.plans.enterprise.name'),
    price: t('kiosk.pricing.plans.enterprise.price'),
    period: t('kiosk.pricing.plans.enterprise.period'),
    description: t('kiosk.pricing.plans.enterprise.description'),
    features: t('kiosk.pricing.plans.enterprise.features', { returnObjects: true }) as string[],
    buttonText: t('kiosk.pricing.buttons.contact'),
    popular: false
  }
];
